module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_j_albino.75f27110.png";